import { render, staticRenderFns } from "./task-client-picker.vue?vue&type=template&id=34e484e4&scoped=true&"
import script from "./task-client-picker.vue?vue&type=script&lang=js&"
export * from "./task-client-picker.vue?vue&type=script&lang=js&"
import style0 from "./task-client-picker.vue?vue&type=style&index=0&id=34e484e4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e484e4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VMenu,VProgressLinear})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34e484e4')) {
      api.createRecord('34e484e4', component.options)
    } else {
      api.reload('34e484e4', component.options)
    }
    module.hot.accept("./task-client-picker.vue?vue&type=template&id=34e484e4&scoped=true&", function () {
      api.rerender('34e484e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tarefas/components/task-client-picker/task-client-picker.vue"
export default component.exports